import { createApi} from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../utilities/refreshTokenUtility";

export const followUpCommentApi = createApi({
  reducerPath: "followUpCommentApi",

  baseQuery: createBaseQueryWithReauth(`${import.meta.env.VITE_BASE_API_URL}FollowUpComment/`),
  endpoints: (builder) => ({
    getAllFollowUpComment: builder.query({
      query: () => ({
        url: "GetFollowUpComments",
        method: "GET",
      }),
    }),

    getReminderByLeadId: builder.query({
      query: (id) => ({
        url: `GetRemindersByLeadId?leadId=${id}`,
        method: "GET",
      }),
    }),

    getReminderByUserId: builder.query({
      query: (id) => ({
        url: `GetRemindersByUserId?userId=${id}`,
        method: "GET",
      }),
    }),

    addFollowUpComment: builder.mutation({
      query: (body) => {
        return {
          url: "AddFollowUpComment",
          method: "POST",
          body,
        };
      },
    }),

    updateFollowUpComment: builder.mutation({
      query: (body) => {
        return {
          url: "UpdateFollowUpComment",
          method: "PUT",
          body,
        };
      },
    }),

    deleteFollowUpComment: builder.mutation({
      query: (id) => ({
        url: `DeleteFollowUpComment?id=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddFollowUpCommentMutation,
  useGetAllFollowUpCommentQuery,
  useGetReminderByLeadIdQuery,
  useGetReminderByUserIdQuery,
  useUpdateFollowUpCommentMutation,
  useDeleteFollowUpCommentMutation,
} = followUpCommentApi;

export default followUpCommentApi.reducer;
